// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getPoolOrderExchangeOrderNumbers ( ) {

    const endPoint = `${basePath}/poolorder-numbers`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getPoolOrderExchangeDetails ( ordernumber ) {

    const endPoint = `${basePath}/poolDetails-results`;
    const payLoad = {
        orderNum: ordernumber.trim()
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}
